export default __webpack_public_path__ + "static/media/SourceSerifPro-Bold.bada4fe1.ttf";